import { useState } from "react";
import { KeyRound, Loader2, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { unlockLibrary } from "../lib/api";

// Passcode gate for the admin-only duck library; the backend verifies it and answers with an httpOnly session cookie.
export const LibraryGate = ({ onGranted }) => {
  const [passcode, setPasscode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await unlockLibrary(passcode.trim());
      setPasscode("");
      onGranted();
    } catch (err) {
      setError(err?.response?.status === 401 ? "That passcode is not right." : err?.response?.status === 429 ? "Too many attempts — please wait a bit." : "Could not reach the library right now.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="library-gate" className="max-w-md rounded-3xl border border-border bg-card/60 p-6 sm:p-8 space-y-4 animate-pop">
      <p className="flex items-center gap-2 text-xs font-mono2 uppercase tracking-widest text-muted-foreground">
        <KeyRound className="h-4 w-4" /> Admin passcode
      </p>
      <h2 className="font-heading text-2xl font-bold tracking-tight">The duck library is private</h2>
      <p className="text-sm text-muted-foreground">Enter the library passcode to browse, import or remove reference ducks. It stays in this tab only.</p>
      <div className="flex gap-2">
        <Input
          type="password"
          autoComplete="off"
          required
          data-testid="library-passcode-input"
          placeholder="Passcode"
          value={passcode}
          onChange={(e) => setPasscode(e.target.value)}
          className="rounded-full h-11"
        />
        <Button type="submit" data-testid="library-passcode-submit" disabled={busy || !passcode.trim()} className="rounded-full h-11 px-5 font-semibold gap-2">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ArrowRight className="h-4 w-4" />} Unlock
        </Button>
      </div>
      {error && (
        <p role="alert" data-testid="library-gate-error" className="text-sm text-destructive">
          {error}
        </p>
      )}
    </form>
  );
};
